import { render, staticRenderFns } from "./claim-total-head.vue?vue&type=template&id=5e9efc2a&scoped=true&"
import script from "./claim-total-head.vue?vue&type=script&lang=js&"
export * from "./claim-total-head.vue?vue&type=script&lang=js&"
import style0 from "./claim-total-head.vue?vue&type=style&index=0&id=5e9efc2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9efc2a",
  null
  
)

export default component.exports